// extracted by mini-css-extract-plugin
export default {"page-header-buttons":"pageHeader_page-header-buttons__++lkx"};